export const CATEGORIES_DATA_URL = '/content-service/guide-categories';

export const GET_CATEGORIES_DATA = 'categories/GET_CATEGORIES_DATA';
export const SET_CATEGORIES_DATA = 'categories/SET_CATEGORIES_DATA';
export const CLEAR_CATEGORIES_DATA = 'categories/CLEAR_CATEGORIES_DATA';

export const CLIENT_PERSPECTIVES = 'CLIENT_PERSPECTIVES';
export const PRACTICE_PERSPECTIVES = 'PRACTICE_PERSPECTIVES';
